import React from "react";
import { Card, CardContent } from "@mui/material";
import Chart from "react-apexcharts";

const ChartCard = ({ options, series }) => (
  <Card>
    <CardContent>
      <Chart options={options} series={series} type="line" height={350} />
    </CardContent>
  </Card>
);

export default ChartCard;
